import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import Group from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {
    detailList,
    section,
    vendorLink,
} from '../user-profile.module.styl';

import type {User} from '../../../openapi/admin/models/User';

type Props = {
    user: User | null,
    vendorName: string,
};

export const UserDetailsCard: React.FC<Props> = ({user, vendorName}) => {
    const renderTextDetail = (label: string, value?: string | number | null) => {
        const textValue = value !== null && value !== undefined ? String(value) : '—';
        return (
            <Group>
                <div style={{maxWidth: 70}}><strong>{label}</strong></div>
                <div style={{maxWidth: 300}}>
                    <Group gap="xs">
                        <EllipsisTextHint title={textValue}>
                            {textValue}
                        </EllipsisTextHint>
                    </Group>
                </div>
            </Group>
        );
    };

    const renderNodeDetail = (label: string, value: React.ReactNode) => (
        <Group>
            <div><strong>{label}</strong></div>
            <div>
                {value}
            </div>
        </Group>
    );

    return (
        <div className={section}>
            <Typography className="font-weight-semi-bold" variant="heading-level-4">
                User Details
            </Typography>
            <div className={detailList}>
                {renderTextDetail('Email:', user?.email)}
                {renderTextDetail('First Name:', user?.firstName)}
                {renderTextDetail('Last Name:', user?.lastName)}
                {user?.vendor ? renderNodeDetail('Vendor Name:', (
                    <FlatButton
                        style={{maxWidth: 300}}
                        as="a"
                        href={`/vendors/${user.vendor.id}`}
                        className={vendorLink}>
                        <EllipsisTextHint title={vendorName}>
                            {vendorName}
                        </EllipsisTextHint>
                    </FlatButton>
                )) : null}
            </div>
        </div>
    );
};
